


































import Store from '@/store';
import { WINDOW_WIDTH, Getters } from '@/store/types';
import { namespace } from 'vuex-class';
import { Watch, Component, Prop, Vue } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { AggregatedOrderTemplateDto, OrderTemplatesApi } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import OrderTemplateButtons from '@/order-template/OrderTemplateButtons.vue';
import MobileUtil from '@/common/MobileUtil';
import MatomoEvents from '@/matomo/events/MatomoEvents';

const windowWidth = namespace(WINDOW_WIDTH);

@Component({ components: { OrderTemplateButtons }})
export default class OrderTemplateEditForm extends Vue {
  public tenant = ConfigService.getTenant();

  public sharedWith: string[] = [];
  public aggregatedOrderTemplateDto: AggregatedOrderTemplateDto = {
    name: '',
    createdBy: {},
    lastEditedBy: {}
  };

  @Prop()
  public localAggregatedOrderTemplateId: string;
  @Prop()
  public localAggregatedOrderTemplateSharedwith: string;

  public hideNotes: boolean = false;

  private api = ApiService.wrap(OrderTemplatesApi);

  @windowWidth.State('windowWidth')
  private windowWidth: number;

  public toggleHideNotes() {
    this.hideNotes = !this.hideNotes;
  }

  public mounted() {
    this.api.getOrderTemplateById(
      ConfigService.getTenant(),
      Number(this.localAggregatedOrderTemplateId),
      ConfigService.currentCustomerId
    ).then((result) => {
      this.aggregatedOrderTemplateDto = result;
    }).catch(ApiService.defaultErrorHandler);
    this.sharedWith = this.getSharedWith();
    this.hideNotes = MobileUtil.isMobile(Store.getters[Getters.WindowWidth.getWindowWidth]());
  }

  public getCreatedUserLabel(): string {
      if (!this.aggregatedOrderTemplateDto.createdBy.firstname
          || ! this.aggregatedOrderTemplateDto.createdBy.lastname) {
          return this.aggregatedOrderTemplateDto.createdBy.username;
      }
      return this.aggregatedOrderTemplateDto.createdBy.firstname + ' '
          + this.aggregatedOrderTemplateDto.createdBy.lastname;
  }

    public getEditedUserLabel(): string {
        if (!this.aggregatedOrderTemplateDto.lastEditedBy.firstname
            || ! this.aggregatedOrderTemplateDto.lastEditedBy.lastname) {
            return this.aggregatedOrderTemplateDto.lastEditedBy.username;
        }
        return this.aggregatedOrderTemplateDto.lastEditedBy.firstname + ' '
            + this.aggregatedOrderTemplateDto.lastEditedBy.lastname;
    }


    public getSharedWith(): string[] {
    if (this.localAggregatedOrderTemplateSharedwith != null) {
      return ConfigService.parseArray(this.localAggregatedOrderTemplateSharedwith);
    }
    return null;
  }

  @Watch('windowWidth')
  private onResize(newValue: number, oldValue: number) {
    if (!MobileUtil.isMobile(newValue)) {
      this.hideNotes = false;
    }
  }

  private changeName() {
    this.updateOrderTemplate();
  }

  private changeComment() {
    this.updateOrderTemplate();
  }

  private updateOrderTemplate() {
    this.api.updateOrderTemplate(
      ConfigService.getTenant(),
      Number(this.localAggregatedOrderTemplateId),
      this.aggregatedOrderTemplateDto,
      ConfigService.currentCustomerId
    ).catch(ApiService.defaultErrorHandler);
    MatomoEvents.forOrderTemplates.change.publish();
  }

  private formatDate(date: string) {
    const formatDate = new Date(date);
    if (new Date().toDateString() === formatDate.toDateString()) {
      return this.$t('orderTemplate.orderTemplateEditForm.todayWithDate',
        { date: formatDate.toLocaleTimeString('de-AT') }).toString();
    } else {
      return this.$t('orderTemplate.orderTemplateEditForm.onDayWithDate',
        { date: formatDate.toLocaleDateString('de-AT') }).toString();
    }
  }

}
